import React from 'react';
import FeedbackStore from './feedback_store';
import mapStateToProps from '../../map_state_to_props';
import FeedbackSummary from '../feedback_summary';
import I18n from 'i18n-js';

interface Props {
  feedbackSummary: FeedbackSummary;
}

class FeedbackSummaryTable extends React.Component<Props, null> {

  get positivePercents() {
    return this.props.feedbackSummary.positive_percent;
  }

  get negativePercents() {
    return this.props.feedbackSummary.negative_percent;
  }

  get feedbackCounts() {
    return this.props.feedbackSummary.counts_formatted;
  }

  render() {
    if (!this.props.feedbackSummary) return null;

    return (
      <div className="feedback-summary-table">
        <div className="weight-bold align-center mb-2">
          {I18n.t('discovery.shop.feedbackSummary.title')}
        </div>
        <table>
          <thead>
            <tr>
              <th />
              <th>{I18n.t('discovery.shop.feedbackSummary.sixMonths')}</th>
              <th>{I18n.t('discovery.shop.feedbackSummary.twelveMonths')}</th>
              <th>{I18n.t('discovery.shop.feedbackSummary.lifetime')}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{I18n.t('discovery.shop.feedbackSummary.positive')}</td>
              <td>{this.positivePercents.recent}%</td>
              <td>{this.positivePercents.middle}%</td>
              <td>{this.positivePercents.all_time}%</td>
            </tr>
            <tr>
              <td>{I18n.t('discovery.shop.feedbackSummary.negative')}</td>
              <td>{this.negativePercents.recent}%</td>
              <td>{this.negativePercents.middle}%</td>
              <td>{this.negativePercents.all_time}%</td>
            </tr>
            <tr>
              <td>{I18n.t('discovery.shop.feedbackSummary.count')}</td>
              <td>{this.feedbackCounts.recent}</td>
              <td>{this.feedbackCounts.middle}</td>
              <td>{this.feedbackCounts.all_time}</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

function mapper() {
  return {
    feedbackSummary: FeedbackStore.getState().feedbackSummary,
  };
}

export default mapStateToProps(
  { mapper, stores: [FeedbackStore] },
)(FeedbackSummaryTable, 'FeedbackSummaryTable');
